var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.339 2.29724C5.45766 -0.765746 10.5148 -0.765746 13.6334 2.29724C16.5751 5.18649 16.7396 9.76775 14.1316 12.8491L19.7076 18.3265C20.0975 18.7094 20.0975 19.33 19.7076 19.7129C19.3178 20.0957 18.6859 20.0957 18.2961 19.7129L12.6742 14.1923C9.55148 16.4223 5.15544 16.1561 2.339 13.39C-0.779668 10.327 -0.779663 5.36022 2.339 2.29724ZM12.2209 3.6836C9.88186 1.38677 6.08942 1.38649 3.75056 3.6836C1.4117 5.9807 1.41198 9.70543 3.75056 12.0027C6.08955 14.2999 9.8819 14.2999 12.2209 12.0027C14.5599 9.70546 14.5599 5.98083 12.2209 3.6836Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1c1f00b341f132009be6a7efdc59f946.svg";
export { ForwardRef as ReactComponent };